import { ClinicalWaitingList } from "@/Common/Api/Lists/Dto/ClinicalWaitingList";
import { PrintHelper } from "@/Common/Helpers/PrintHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { ClinicalWaitingListItem } from "@/Lists/Api/Dto/Response/ClinicalWaitingListItem";
import { ClinicalWaitingListTableItem } from "@/Lists/Api/Dto/Response/ClinicalWaitingListTableItem";
import { ListsStore } from "@/Lists/Stores/ListsStore";

class ListsResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_LoadClinicalWaitingLists, this.LoadClinicalWaitingLists);
        this.RegisterOperation(ServerOperations.Server.Myle_AddNewClinicalWaitingList, this.AddNewClinicalWaitingList);
        this.RegisterOperation(ServerOperations.Server.Myle_SearchClinicalWaitingListItems, this.SearchClinicalWaitingListItems);
        this.RegisterOperation(ServerOperations.Server.Myle_EditClinicalWaitingListName, this.EditClinicalWaitingListName);
        this.RegisterOperation(ServerOperations.Server.Myle_DeleteItemFromClinicalWaitingList, this.DeleteItemFromClinicalWaitingList);
        this.RegisterOperation(ServerOperations.Server.Myle_DeleteClinicalWaitingList, this.DeleteClinicalWaitingList);
        this.RegisterOperation(ServerOperations.Server.Myle_AddNewItemToWaitingList, this.AddNewItemToWaitingList);
        this.RegisterOperation(ServerOperations.Server.Myle_CheckIfSelectedPatientExists, this.CheckIfSelectedPatientExists);
        this.RegisterOperation(ServerOperations.Server.Myle_EditAnItemOfWaitingList, this.EditAnItemOfWaitingList);
        this.RegisterOperation(ServerOperations.Server.Myle_Lists_GeneratePDF, this.GenerateClinicalWaitingListsPDF);
    }

    private EditAnItemOfWaitingList(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsDone) {
            store.ListsAction.searchListItems(store.ListModel);
        }
    }

    private CheckIfSelectedPatientExists(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsExits) {
            store.ListCreateAndEditItemModel = store.ListCreateAndEditItemModel.set("IsSelectedPatientExists", true);
        }
    }

    private AddNewItemToWaitingList(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsDone) {
            store.ListsAction.searchListItems(store.ListModel);
            store.ListsAction.loadLists(store.ListsTabModel);
        }
    }

    private DeleteClinicalWaitingList(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsDone) {
            store.ListsTabModel = store.ListsTabModel.set("IsAnyListSelected", false);
            store.ListsAction.loadLists(store.ListsTabModel);
        }
    }

    private DeleteItemFromClinicalWaitingList(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsDone) {
            store.ListsAction.loadLists(store.ListsTabModel);
            store.ListsAction.searchListItems(store.ListModel);
        }
    }

    private EditClinicalWaitingListName(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsDone) {
            store.ListsAction.loadLists(store.ListsTabModel);
            store.ListModel = store.ListModel.set("ListName", response.Data.ListCurrentName);
            store.ListModel = store.ListModel.set("ShowEditListNamePopup", false);
        }
    }

    private SearchClinicalWaitingListItems(response: ServerEvent, store: ListsStore): void {
        let TableItems = response.Data.ListItems.map(x => new ClinicalWaitingListTableItem(ClinicalWaitingListItem.FromResponse(x)));
        store.ListModel = store.ListModel.set("TotalQueryPages", response.Data.TotalQueryPages);
        store.ListModel = store.ListModel.set("TotalQueryRows", response.Data.TotalQueryRows);
        store.ListModel = store.ListModel.set("CurrentPage", response.Data.CurrentPage);
        store.ListModel = store.ListModel.set("TableData", Immutable.List<ClinicalWaitingListTableItem>(TableItems));

        store.ListsTabModel = store.ListsTabModel.set("IsAnyListSelected", true);
    }

    private AddNewClinicalWaitingList(response: ServerEvent, store: ListsStore): void {
        if (response.Data.IsDone) {
            const searchText = store.ListsTabModel.get("SearchText");
            const pageSize = store.ListsTabModel.get("PageSize");
            store.InitializeListModel();
            store.ListModel = store.ListModel.set("ListId", response.Data.ListId);
            store.ListModel = store.ListModel.set("ListName", response.Data.ListName);
            store.ListsTabModel = store.ListsTabModel.set("SelectedItemId", response.Data.ListId);
            store.ListsTabModel = store.ListsTabModel.set("IsAnyListSelected", true);
            if (!searchText)
                store.ListsTabModel = store.ListsTabModel.set("SearchText", searchText);
            if (!pageSize)
                store.ListsTabModel = store.ListsTabModel.set("PageSize", pageSize);

            store.ListsAction.loadLists(store.ListsTabModel);
            store.ListsAction.searchListItems(store.ListModel);
        }
    }

    private LoadClinicalWaitingLists(response: ServerEvent, store: ListsStore): void {
        var Lists: ClinicalWaitingList[] = response.Data["ClinicalWaitingLists"];
        store.ListsTabModel = store.ListsTabModel.set("ClinicalWaitingLists", Immutable.List<ClinicalWaitingList>(Lists));
        sessionStore.hideGlobalOverlay();
    }

    private GenerateClinicalWaitingListsPDF(response: ServerEvent): void {
        PrintHelper.ShowPrintPreviewFileName(response.Data.FileName);
    }
}

export { ListsResponseHandler };
